<template>
  <el-form label-position="top" :model="currIngredient" :rules="rules" ref="ingredientForm">
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item
          label="Összetevő"
          prop="ingredient"
          v-loading="productLoading"
        >
          <el-select
            v-if="products && products.length"
            v-model="currIngredient.ingredient"
            value-key="id"
            style="width: 100%;"
            :default-first-option="true"
            filterable
            @change="currIngredient.ingredient_id = currIngredient.ingredient.id"

          >
            <el-option
              v-for="product in products"
              :key="product.id"
              :value="product"
              :label="product.name"
              :disabled="isDisabled(product.id)"
            >
              {{ product.name }} <el-tag v-if="isDisabled(product.id)" type="danger" size="mini" style="margin-left: 5px">Kiválasztva</el-tag>
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          label="Mennyiség"
          prop="count"
        >
          <el-input-number
            v-model.number="currIngredient.count"
            precision=0
            style="width: 100%;"
          />
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
  export default {
    props: ['defaultIngredient', 'formType', 'ingredients'],
    data() {
      return {
        productLoading: false,
        products: [],
        selectedIngredientIds: [],
        currIngredientId: 0,
        currIngredient: {
          ingredient: {},
          count: 1,
        },
        rules: {
          ingredient: [
            {
              required: true,
              message: 'Összetevő megadása kötelező',
              trigger: 'change'
            }
          ],
          count: [
            {
              required: true,
              message: 'Mennyiség megadása kötelező',
              trigger: 'change'
            }
          ]
        }
      };
    },

    watch: {
      defaultIngredient: {
        handler(newVal) {
          this.currIngredient = Object.assign({}, newVal);
          this.currIngredientId = this.currIngredient.ingredient_id;
        },
        deep: true,
      },

      ingredients: {
        handler(newVal) {
          this.selectedIngredientIds = newVal.map(i => i.ingredient.id);
        }
      }
    },
    async mounted() {
      this.productLoading = true;
      this.products = await this.$store.dispatch('product/search');
      if (this.formType === 'add') {
        this.currIngredient = {
          count: 1,
        };
      } else {
        this.currIngredient = Object.assign({}, this.defaultIngredient, {});
        this.currIngredientId = this.currIngredient.ingredient_id;
      }
      this.selectedIngredientIds = this.ingredients.map(i => i.ingredient.id);
      this.productLoading = false;
    },

    methods: {
      isDisabled(productId) {
        return this.selectedIngredientIds.includes(productId) && productId !== this.currIngredientId;
      }
    }
  };
</script>
